import Pages from "../layouts/Pages";
// import RTL from "layouts/RTL.jsx";
import Dashboard from "../layouts/Dashboard";

export const indexRoutes = [
  { path: "/", name: "Home", component: Dashboard }
];

export const mainRoutes= [
  { path: "/admin/pages", name: "Pages", component: Pages },
]
